<template>
  <div class="switchTopics">
    <div id="mapType-wrapper" class="myType-wrapper" @mouseenter="onMouseenter" @mouseleave="onMouseleave">
      <div id="mapType" class="mapType" :class="'o' + mapTypeList.length">
        <div
          v-for="(item, index) in mapTypeList"
          :key="index"
          class="mapTypeCard"
          :class="[item.mapType, 'o' + (index + 1), item.isDefault ? 'active' : '']"
          @click="handleCLick(item, $event)"
        >
          <span>{{ MAP_TYPE[item.mapType] }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mixins: [],
  data() {
    return {
      mapTypeList: [],
      map: null,
      mapUtils: null,
      baseTDTServiceGroup: null,
      imgTDTServiceGroup: null,
      normalTDTServiceGroup: null,
      LayerGroup: null,
      MAP_TYPE: {
        satelite: '影像地图',
        normal: '电子地图',
        panorama: '地形地图'
      }
    }
  },
  mounted() {
    this.$event.$on('ready', map => {
      const LayerGroup = L.featureGroup().addTo(map)
      this.LayerGroup = LayerGroup
      this.onlineTianDitu(map)
      // this.loadGeoQMap(map)
      this.addMyMapEventlistener(map)
    })
  },
  methods: {
    // 添加地图事件
    addMyMapEventlistener(map) {
      debugger
      if (map) {
        map.on('zoomend', e => {
          const zoomL = map.getZoom()

          const imga = L.tiandituTileLayer({ layerType: 'cia', key: '1d109683f4d84198e37a38c442d68311' })
          if (zoomL >= 15) {
            this.LayerGroup.addLayer(imga)
          } else {
            this.LayerGroup.clearLayers()
          }
        })
      } else {
        console.log('地图监听事件错误....')
      }
    },
    loadGeoQMap(map) {
      const normalm1 = L.tileLayer.chinaProvider('Geoq.Normal.Map', {
        maxZoom: 18,
        minZoom: 5
      })
      const normalm2 = L.tileLayer.chinaProvider('Geoq.Normal.PurplishBlue', {
        maxZoom: 18,
        minZoom: 5
      })
      const normalm3 = L.tileLayer.chinaProvider('Geoq.Normal.Gray', {
        maxZoom: 18,
        minZoom: 5
      })
      const normalm4 = L.tileLayer.chinaProvider('Geoq.Normal.Warm', {
        maxZoom: 18,
        minZoom: 5
      })
      const normalm5 = L.tileLayer.chinaProvider('Geoq.Theme.Hydro', {
        maxZoom: 18,
        minZoom: 5
      })
      //   const normal = L.layerGroup([normalm1, normalm2, normalm3, normalm4, normalm5])

      const baseLayers = {
        地图: normalm1,
        午夜蓝: normalm2,
        灰色: normalm3,
        暖色: normalm4,
        水系: normalm5
      }

      const att = L.control.attribution().addTo(map)
      att.addAttribution('智图geoq')
      /*   const normalm2group = L.layerGroup([normalm2])
      normalm2group.addTo(map)
 */
      const normalm3group = L.layerGroup([normalm3])
      normalm3group.addTo(map)

      /*  const normalm4group = L.layerGroup([normalm4])
      normalm4group.addTo(map)

      const normalm5group = L.layerGroup([normalm5])
      normalm5group.addTo(map) */

      /*   const mapArray = []
      mapArray.push(normalm3group)
      mapArray.push(normalm4group)
      mapArray.push(normalm5group) */

      // this.mapTypeList = mapArray
      // this.switchGeoqMap(normalm3group)
      // L.control.layers(baseLayers, null).addTo(map)
    },
    onlineTianDitu(map) {
      this.map = map
      this.baseTDTServiceGroup = L.layerGroup()
      this.baseTDTServiceGroup.type = 'sysServer'
      this.baseTDTServiceGroup.addTo(this.map)

      const imgm = L.tiandituTileLayer({ layerType: 'img', key: '1d109683f4d84198e37a38c442d68311' })
      imgm.type = 'sysServer'
      const imga = L.tiandituTileLayer({ layerType: 'cia', key: '1d109683f4d84198e37a38c442d68311' })
      imga.type = 'sysServer'
      imga.setOpacity(0)

      const normalm = L.tiandituTileLayer({ layerType: 'vec', key: '1d109683f4d84198e37a38c442d68311' })
      normalm.type = 'sysServer'
      const normala = L.tiandituTileLayer({ layerType: 'cva', key: '1d109683f4d84198e37a38c442d68311' })
      normala.type = 'sysServer'

      const terlayer = L.tiandituTileLayer({ layerType: 'ter', key: '1d109683f4d84198e37a38c442d68311' })
      terlayer.type = 'sysServer'
      const tercva = L.tiandituTileLayer({ layerType: 'cva', key: '1d109683f4d84198e37a38c442d68311' })
      tercva.type = 'sysServer'

      const image = L.layerGroup([imgm])
      image.isDefault = true
      image.mapType = 'satelite'
      image.type = 'sysServer'
      image.addTo(this.map)

      const normal = L.layerGroup([normalm, normala])
      normal.mapType = 'normal'
      normal.type = 'sysServer'
      normal.addTo(this.map)

      const panorama = L.layerGroup([terlayer, tercva])
      panorama.mapType = 'panorama'
      panorama.type = 'sysServer'
      panorama.addTo(this.map)

      const mapArray = []
      mapArray.push(image)
      mapArray.push(normal)
      mapArray.push(panorama)

      this.mapTypeList = mapArray
      this.switchMap(image)
    },

    onMouseenter(e) {
      e.target.classList.add('expand')
    },
    onMouseleave(e) {
      e.target.classList.remove('expand')
    },
    handleCLick(item, e) {
      const activeItems = document.getElementsByClassName('mapTypeCard active')
      for (const d of activeItems) {
        d.classList.remove('active')
      }
      e.target.classList.add('active')
      this.switchMap(item)
    },
    switchGeoqMap(item) {
      debugger
      const array = this.mapTypeList
      debugger
      for (let index = 0; index < array.length; index++) {
        const element = array[index]
        if (item === element) {
          const layers = element.getLayers()
          for (let i = 0; i < layers.length; i++) {
            const layer = layers[i]
            layer.setOpacity(1)
          }
        } else {
          const layers = element.getLayers()
          for (let i = 0; i < layers.length; i++) {
            const layer = layers[i]
            layer.setOpacity(0)
          }
        }
      }
    },
    switchMap(item) {
      const array = this.mapTypeList
      debugger
      for (let index = 0; index < array.length; index++) {
        const element = array[index]
        if (item === element) {
          const layers = element.getLayers()
          for (let i = 0; i < layers.length; i++) {
            const layer = layers[i]
            layer.setOpacity(1)
          }
        } else {
          const layers = element.getLayers()
          for (let i = 0; i < layers.length; i++) {
            const layer = layers[i]
            layer.setOpacity(0)
          }
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.switchTopics {
  position: absolute;
  bottom: 10px;
  right: 5px;
  z-index: 499;
  overflow: hidden;
}

.mapType {
  height: 80px;
  cursor: pointer;
  -webkit-transition-property: width, background-color;
  transition-property: width, background-color;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
  width: 110px;
  background-color: rgba(255, 255, 255, 0);
  /* user-select: none�*/
}

.mapType .switch-box {
  visibility: hidden;
  position: absolute;
  width: 100%;
  height: 20px;
  line-height: 20px;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
}

.mapType .normal .switch-box input.switch {
  left: 2px;
}

.mapType .switch-box input.switch {
  position: absolute;
  left: 2px;
  top: 2px;
  cursor: pointer;
}

.mapType .normal .switch-box p {
  margin: 0 0 0 21px;
}

.mapType .switch-box p {
  display: inline-block;
  margin: 0 0 0 21px;
}

.expand .mapType {
  background-color: rgba(0, 0, 0, 0.1);
}

.expand .mapType.o2 {
  width: 200px;
}

.expand .mapType.o3 {
  width: 290px;
}

.expand .mapType.o4 {
  width: 380px;
}

.expand .mapType .mapTypeCard {
  border: 1px solid rgba(255, 255, 255, 0);
}

.mapType .active {
  z-index: 490;
  border: 1px solid #3385ff;
}

.mapType .mapTypeCard {
  background-image: url('./img/maptype.png');
  height: 60px;
  width: 86px;
  position: absolute;
  border-radius: 4px;
  top: 10px;
  box-sizing: border-box;
  /*  border: 1px solid transparent;
      border: 1px solid rgba(153,153,153,.42);
     background: url(./img/shadow.png) no-repeat 0 0;  */
  background-size: 86px 240px;
  -webkit-transition-property: right, background-image;
  transition-property: right, background-image;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
}

.myType-wrapper .mapType .mapTypeCard:hover {
  border: solid 1px #3385ff;
}

.mapType .mapTypeCard.active span,
.mapType .mapTypeCard:hover span {
  background-color: #3385ff;
}

.mapType .mapTypeCard span {
  position: absolute;
  bottom: 0;
  right: 0;
  display: inline-block;
  padding: 3px 3px 2px 4px;
  font-size: 12px;
  /*height: 12px;*/
  line-height: 12px;
  color: #fff;
  border-top-left-radius: 2px;
}

.mapType .normal {
  background-position: 0 0;
}

.mapType .earth {
  background-position: 0 -361px;
}

.mapType .satelite {
  background-position: 0 -181px;
}

.mapType .panorama {
  background-position: 0 -300px;
}

.expand .mapType {
  width: 200px;
  background-color: rgba(0, 0, 0, 0.1);
}

.expand .mapType .mapTypeCard {
  border: 1px solid rgba(255, 255, 255, 0);
}

.mapType .active {
  z-index: 999 !important;
  border: 1px solid #3385ff;
}

.expand .mapType .mapTypeCard.active {
  border: 1px solid #3385ff;
}

.expand .mapType .mapTypeCard {
  border: 1px solid rgba(255, 255, 255, 1);
  /*  background-image: url(./img/maptype.png);*/
}

.mapType .mapTypeCard:hover .switch-box {
  visibility: visible;
}

.mapType .o1 {
  z-index: 1;
  right: 5px;
}

.mapType .o2 {
  z-index: 2;
  right: 15px;
}

.mapType .o3 {
  right: 25px;
}

.mapType .o4 {
  right: 35px;
}

.expand .mapType .o1 {
  right: 5px;
}

.expand .mapType .o2 {
  right: 100px;
}

.expand .mapType .o3 {
  right: 195px;
}

.expand .mapType .o4 {
  right: 295px;
}
</style>
